import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useBooking } from "./BookingContext";

const Step5 = () => {
  const { bookingData } = useBooking();
  const [amount, setAmount] = useState(0);
  const [isValid, setIsValid] = useState(false);

  // Memoize price calculation
  const calculateAmount = useCallback(() => {
    console.log("Calculating amount with:", {
      plan: bookingData.plan,
      package: bookingData.package,
    });

    if (bookingData.plan && bookingData.package) {
      const prices = {
        daily: {
          basic: 4000,
          private: 14300,
        },
        weekly: {
          basic: 19500,
          private: 65000,
        },
        monthly: {
          basic: 78500,
          private: 234000,
        },
      };

      const planPrices = prices[bookingData.plan];
      if (planPrices && planPrices[bookingData.package]) {
        const calculatedAmount = planPrices[bookingData.package];
        console.log("Calculated amount:", calculatedAmount);

        setAmount(calculatedAmount);

        // Set the amount in the hidden input for the jQuery script
        const amountInput = document.getElementById("amount");
        if (amountInput) {
          amountInput.value = calculatedAmount;
        }

        // Also set the amount in localStorage for jQuery access
        localStorage.setItem("bookingAmount", calculatedAmount);

        setIsValid(true);
        return calculatedAmount;
      } else {
        console.error(
          "Invalid plan/package combination:",
          bookingData.plan,
          bookingData.package
        );
        setIsValid(false);
        return 0;
      }
    } else {
      console.error(
        "Missing plan or package:",
        bookingData.plan,
        bookingData.package
      );
      setIsValid(false);
      return 0;
    }
  }, [bookingData.plan, bookingData.package]);

  // Use useMemo to prevent unnecessary calculations
  const calculatedAmount = useMemo(() => {
    return calculateAmount();
  }, [calculateAmount]);

  // Only run once when component mounts or when bookingData changes significantly
  useEffect(() => {
    calculateAmount();

    // Initialize payment button after a delay
    const timer = setTimeout(() => {
      if (window.initializePaymentButton) {
        window.initializePaymentButton();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [calculateAmount]); // Only depend on the memoized calculateAmount

  // In Step5.jsx useEffect
  useEffect(() => {
    let mounted = true;

    const initPayment = () => {
      if (mounted && window.initializePaymentButton) {
        window.initializePaymentButton();
      }
    };

    calculateAmount();

    const timer = setTimeout(initPayment, 500);

    return () => {
      mounted = false;
      clearTimeout(timer);
    };
  }, [calculateAmount]);

  const handlePayClick = useCallback(() => {
    console.log("Pay button clicked with validity:", isValid);
    console.log("Current booking data:", bookingData);

    if (!isValid) {
      alert(
        "Please go back and complete all steps before making payment. Make sure to select both a plan and a package."
      );
      return;
    }

    // Trigger the jQuery payment button click
    const payButton = document.getElementById("pay-btn");
    if (payButton) {
      payButton.click();
    }
  }, [isValid, bookingData]);

  return (
    <div className="multisteps-form__panel" data-animation="slideHorz">
      <div className="wizard-forms">
        <div className="inner pb-100 clearfix cont">
          <div className="form-content pera-content">
            <div className="step-inner-content">
              <span className="step-no bottom-line">Step 5</span>
              <div className="step-progress float-end">
                <span>5 of 5 completed</span>
                <div className="step-progress-bar">
                  <div className="progress">
                    <div
                      className="progress-bar"
                      style={{ width: "100%" }}
                    ></div>
                  </div>
                </div>
              </div>

              <h2>Please, Make Your Payment</h2>
              <p>kindly proceed with your payment to continue</p>
              <div className="booking-summary mb-4 p-3 bg-light rounded">
                <h5>Booking Summary:</h5>
                <p>
                  <strong>Plan:</strong>{" "}
                  {bookingData.plan
                    ? bookingData.plan.charAt(0).toUpperCase() +
                      bookingData.plan.slice(1)
                    : "Not selected"}
                </p>
                <p>
                  <strong>Package:</strong>{" "}
                  {bookingData.package
                    ? bookingData.package.charAt(0).toUpperCase() +
                      bookingData.package.slice(1)
                    : "Not selected"}
                </p>
                <p>
                  <p><strong>Amount:</strong> ₦{amount ? amount.toLocaleString() : '0'}</p>
                </p>
                {!isValid && (
                  <div className="alert alert-warning">
                    <strong>Warning:</strong> Please complete all previous steps
                    before making payment.
                    {!bookingData.plan && (
                      <div>• Please select a plan in Step 1</div>
                    )}
                    {!bookingData.package && (
                      <div>• Please select a package in Step 3</div>
                    )}
                  </div>
                )}
              </div>

              <input
                type="hidden"
                id="amount"
                name="amount"
                value={amount}
                data-plan={bookingData.plan}
                data-package={bookingData.package}
              />

              {/* <input type="text" id="amount" name="amount" hidden /> */}
              <div className="step-content-area">
                <button
                  id="pay-btn"
                  type="button"
                  style={{
                    height: "50px",
                    width: "150px",
                    color: "white",
                    backgroundColor: "#8a038c",
                    border: "none",
                    borderRadius: "2%",
                    cursor: isValid ? "pointer" : "not-allowed",
                  }}
                  disabled={!isValid}
                  onClick={handlePayClick}
                >
                  {isValid ? "Pay now" : "Complete steps first"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="actions">
          <ul>
            <li>
              <span className="js-btn-prev" title="BACK">
                <i className="fa fa-arrow-left"></i> BACK{" "}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default Step5;
